export default __webpack_public_path__ + "img/olivertree_artroom-01.d8351bf5470ad4191eabc31638e73027.png";